import styled from "styled-components";

export const Checkbox = styled.div`
  color: #01509C;

  input[type=checkbox] {
    margin-right: 10px;
  }
`;

export const modalStyle = {
  borderRadius: '10px 10px'
};